import { useLocation, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import homeService, { HomePageData } from "../services/HomeService";

// Returns home page data for the date passed via navigation state (or today if not set)
export function useHomeDataForDate() {
  const location = useLocation();

  const getLocalDateString = (date: Date = new Date()) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // try to derive a date string from either query param or location state
  const [searchParams] = useSearchParams();
  const paramDate = searchParams.get("date") || undefined;

  let derivedDate: string | undefined = undefined;
  if (paramDate) {
    derivedDate = paramDate;
  } else if (location.state && (location.state as any).selectedDate) {
    derivedDate = (location.state as any).selectedDate;
  } else if (location.state && (location.state as any).selectedDateObj) {
    const dt = new Date((location.state as any).selectedDateObj);
    derivedDate = getLocalDateString(dt);
  }
  const selectedDate = derivedDate || getLocalDateString();

  const formattedSelectedDate = new Date(selectedDate + "T00:00:00").toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const query = useQuery<HomePageData>({
    queryKey: ["homePageData", selectedDate],
    queryFn: () => homeService.getHomePageData(selectedDate),
    staleTime: 2 * 60 * 1000,
    refetchOnMount: false,
  });

  return {
    ...query,
    selectedDate,
    formattedSelectedDate,
  };
}
